import React from 'react';
import ReactDOM from 'react-dom/client';
import NotificationLightbox from './NotificationLightbox';

const container = document.createElement('div');
document.body.appendChild(container);
const root = ReactDOM.createRoot(container);

// Use a mutable object to store the ref
const notificationRef = { current: null };

// Wrapper component to capture ref using callback ref
const NotificationWrapper = () => {
  const setRef = (ref) => {
    notificationRef.current = ref;
  };
  
  return <NotificationLightbox ref={setRef} />;
};

root.render(<NotificationWrapper />);

export const notificationAPI = {
  show: (options) => {
    // Wait a bit for ref to be set if not ready
    if (!notificationRef.current) {
      setTimeout(() => {
        if (notificationRef.current) {
          notificationAPI.show(options);
        }
      }, 10);
      return;
    }

    // Create fresh callbacks object for this show call
    const callbacks = {
      onDestroy: options?.onDestroy,
      onRendered: options?.onRendered
    };

    // Remove callbacks from options
    const { onDestroy, onRendered, ...showOptions } = options;

    notificationRef.current.show({
      ...showOptions,
      _callbacks: callbacks  // Pass callbacks separately
    });
  },
  
  update: (options) => {
    if (!notificationRef.current) return;
    notificationRef.current.update(options);
  },
  
  hide: () => {
    if (!notificationRef.current) return;
    notificationRef.current.hide();
  }
};